export default __webpack_public_path__ + "static/media/book.a6aac04b.ogg";